import { createTheme } from "@mui/material/styles";

const professionalTeal = {
    main: "#1976d2",
    dark: "#2A7A76",
    light: "#E6F6F5",
    contrastText: "#fff"
};

const customOfficial = {
    main: "#f06310",
    dark: "#12332e",
    light: "#facc22"
};
const buttonOfficial = {
    main: "#f06310",
    dark: "#A84742",
    light: "#facc22"
};

const theme = createTheme({
    palette: {
        primary: {
            main: "#C25953", // Updated primary main to official terracotta
            dark: "#A84742",
            contrastText: "#FFFFFF"
        },
        secondary: {
            main: "#455a64"
        },
        teal: professionalTeal,
        official: customOfficial,
        background: {
            default: "#f5f5f5"
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: "none" // Keeps modern typography
                },

                // --- 1. CONTAINED BUTTONS ---
                contained: {
                    backgroundColor: buttonOfficial.main,
                    color: "#FFFFFF",
                    "&:hover": {
                        backgroundColor: "#A84742"
                    },
                    "&.Mui-disabled": {
                        backgroundColor: "rgba(194, 89, 83, 0.15)",
                        color: "rgba(194, 89, 83, 0.5)"
                    }
                },

                // --- 2. OUTLINED (CANCEL) BUTTONS ---
                outlined: {
                    border: "1.5px solid rgba(194, 89, 83, 0.2)", // 👈 Soft subtle border
                    color: customOfficial.main, // Sharp brand text
                    fontWeight: 600,
                    backgroundColor: "transparent",
                    transition: "all 0.2s ease-in-out",

                    "&:hover": {
                        border: "1.5px solid #A84742", // Solidifies on hover for clear focus
                        backgroundColor: "rgba(194, 89, 83, 0.08)", // Soft warm fill
                        color: buttonOfficial.main,
                        boxShadow: "0 2px 8px rgba(194, 89, 83, 0.12)"
                    },
                    "&:active": {
                        backgroundColor: "rgba(194, 89, 83, 0.16)"
                    },
                    "&.Mui-disabled": {
                        border: "1.5px solid rgba(194, 89, 83, 0.1)",
                        color: "rgba(194, 89, 83, 0.4)",
                        backgroundColor: "transparent"
                    }
                },

                // --- 3. TEXT BUTTONS ---
                text: {
                    color: buttonOfficial.main,
                    backgroundColor: "transparent",
                    "&:hover": {
                        backgroundColor: "#FDF5F4"
                    },
                    "&.Mui-disabled": {
                        color: "rgba(194, 89, 83, 0.4)"
                    }
                }
            }
        }
    },

    typography: {
        fontFamily: [
            "Franklin Gothic Book",
            "Roboto",
            "Arial",
            "sans-serif"
        ].join(",")
    },

    shape: {
        borderRadius: 8
    }
});

export default theme;
